module.exports = __webpack_public_path__ + "img/bird-11-right.c17f3c62.png";